import "./App.css";
import Navegacao from "./components/Navegacao.js";
import Footer from "./components/Footer";


function App() {
  return (
    <div className="App">
      <Navegacao />
      <Footer />
    </div>
  );
}

export default App;
